class ProductMatchingWays extends HTMLElement {
  constructor() {
    super();
    console.log('ProductMatchingWays constructor called');
    
    // 存储产品数据和已选择的产品
    this.productData = {};
    this.selectedProducts = {};
    this.currency = Shopify.currency ? Shopify.currency.active : 'HK$';
    
    // 添加货币转换相关属性
    this.hasCurrencyConverter = false;
    this.convertedCurrency = '';
    this.currencySymbol = '';
    this.fullCurrencyText = '';
    
    // 添加缓存属性
    this.conversionRateCache = {
      rate: null,
      timestamp: 0,
      currencyFormat: ''
    };
  }

  connectedCallback() {
    console.log('ProductMatchingWays connected to DOM');
    this.initializeFromExistingDOM();
    
    // 检测货币转换插件
    this.detectCurrencyConverter();
    
    // 设置货币转换监听器
    this.setupCurrencyConversionObserver();
    
    // 添加价格元素观察器
    this.setupPriceElementObserver();
  }

  async initializeFromExistingDOM() {
    try {
      console.log('从已有DOM初始化匹配产品组件');
      
      // 从全局变量或属性获取元字段数据
      if (window.matchingProductsData) {
        this.metafieldData = window.matchingProductsData;
        console.log('成功从全局变量获取元字段数据:', this.metafieldData);
      } else {
        const metafieldsData = this.getAttribute('data-metafields');
        if (metafieldsData) {
          try {
            const parsedData = JSON.parse(metafieldsData);
            this.metafieldData = parsedData.value || parsedData;
            console.log('成功从属性解析元字段数据:', this.metafieldData);
          } catch (error) {
            console.error('解析元字段数据错误:', error);
          }
        }
      }
      
      // 初始化选择的产品对象
      const groups = document.querySelectorAll('.matching-ways-block');
      console.log(`找到 ${groups.length} 个产品组`);
      
      groups.forEach((group, index) => {
        const groupIndex = group.getAttribute('data-group-index') || index;
        console.log(`初始化产品组 ${groupIndex}`);
        
        if (!this.selectedProducts[groupIndex]) {
          this.selectedProducts[groupIndex] = {};
        }
        
        // 检查这个组内是否有产品项
        const items = group.querySelectorAll('.matching-product-item');
        console.log(`产品组 ${groupIndex} 包含 ${items.length} 个产品项`);
      });
      
      // 设置事件监听器
      this.setupEventListeners();
      
      // 加载产品图片和信息
      this.loadProductImages();
    } catch (error) {
      console.error('初始化匹配产品组件错误:', error);
    }
  }
  
  setupEventListeners() {
    // 数量减少按钮
    document.querySelectorAll('.quantity-minus').forEach(button => {
      button.addEventListener('click', (e) => {
        const item = e.target.closest('.matching-product-item');
        const input = item.querySelector('.quantity-input');
        const variantId = item.getAttribute('data-variant-id');
        const groupIndex = item.getAttribute('data-group-index');
        
        let value = parseInt(input.value) || 0;
        if (value > 0) {
          value--;
          input.value = value;
          this.updateProductSelection(variantId, value, groupIndex);
        }
      });
    });
    
    // 数量增加按钮
    document.querySelectorAll('.quantity-plus').forEach(button => {
      button.addEventListener('click', (e) => {
        const item = e.target.closest('.matching-product-item');
        const input = item.querySelector('.quantity-input');
        const variantId = item.getAttribute('data-variant-id');
        const groupIndex = item.getAttribute('data-group-index');
        
        let value = parseInt(input.value) || 0;
        value++;
        input.value = value;
        this.updateProductSelection(variantId, value, groupIndex);
      });
    });
    
    // 数量输入框
    document.querySelectorAll('.quantity-input').forEach(input => {
      input.addEventListener('change', (e) => {
        const item = e.target.closest('.matching-product-item');
        const variantId = item.getAttribute('data-variant-id');
        const groupIndex = item.getAttribute('data-group-index');
        const value = parseInt(e.target.value) || 0;
        
        e.target.value = Math.max(0, value);
        this.updateProductSelection(variantId, e.target.value, groupIndex);
      });
    });
    
    // 产品图片点击 - 修改为调用updatePriceSummary而不是showSingleProductPrice
    document.querySelectorAll('.matching-product-link').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        const item = link.closest('.matching-product-item');
        const groupIndex = item.getAttribute('data-group-index');
        
        // 更新价格摘要，显示整个组的总价
        this.updatePriceSummary(groupIndex);
        
        return false;
      });
    });
  }
  
  updateProductSelection(variantId, quantity, groupIndex) {
    // 确保分组存在
    if (!this.selectedProducts[groupIndex]) {
      this.selectedProducts[groupIndex] = {};
    }
    
    // 更新选择
    quantity = parseInt(quantity) || 0;
    
    if (quantity > 0) {
      // 检查是否可以从隐藏价格字段获取价格
      const item = document.querySelector(`.matching-product-item[data-variant-id="${variantId}"]`);
      let price = 0;
      
      if (item) {
        const hiddenPriceField = item.querySelector('.hidden-product-price .cbb-currency');
        if (hiddenPriceField) {
          // 从隐藏价格字段获取价格（移除货币符号）
          const priceText = hiddenPriceField.textContent.replace(/[^0-9.]/g, '');
          price = parseFloat(priceText) || 0;
        }
      }
      
      // 如果没有从隐藏字段获取到价格，则使用存储的价格数据
      if (price === 0 && this.productData[variantId]) {
        price = this.productData[variantId].price || 0;
      }
      
      // 确保产品数据存在
      if (!this.productData[variantId]) {
        this.productData[variantId] = {
          title: `Product ${variantId}`,
          price: price
        };
      } else {
        // 更新价格
        this.productData[variantId].price = price;
      }
      
      this.selectedProducts[groupIndex][variantId] = {
        quantity: quantity,
        ...this.productData[variantId]
      };
    } else {
      delete this.selectedProducts[groupIndex][variantId];
    }
    
    // 更新摘要显示
    this.updateSummary(groupIndex);
    
    // 更新价格摘要，汇总整个bundle list的价格
    this.updatePriceSummary(groupIndex);
    
    // 触发自定义事件，通知其他组件选择已更新
    this.dispatchEvent(new CustomEvent('matching-products-updated', {
      bubbles: true,
      detail: { selectedProducts: this.selectedProducts }
    }));
  }
  
  updateSummary(groupIndex) {
    const summaryEl = document.querySelector(`#summary-${groupIndex}`);
    if (!summaryEl) return;
    
    const selectedGroup = this.selectedProducts[groupIndex] || {};
    const productsInfo = [];
    let totalPrice = 0;
    
    // 收集已选产品信息，优先使用name字段
    Object.entries(selectedGroup).forEach(([variantId, product]) => {
      if (product.quantity > 0) {
        // 优先使用完整name字段，否则再组合其他字段
        let displayName = '';
        
        if (product.title) {
          // 如果有name字段（完整产品名称），直接使用
          displayName = product.title;
        } else {
          // 否则组合产品名称和变体名称
          const productTitle = product.product_title || '';
          const variantTitle = product.title || '';
          
          if (productTitle && variantTitle && variantTitle !== 'Default Title') {
            displayName = `${productTitle} - ${variantTitle}`;
          } else {
            displayName = productTitle || variantTitle || `Product ${variantId}`;
          }
        }
        
        productsInfo.push(`${displayName} × ${product.quantity}`);
        
        // 获取价格并修复单位问题
        let productPrice = product.price || 0;
        productPrice = this.adjustPriceUnit(productPrice);
        
        totalPrice += productPrice * product.quantity;
      }
    });
    
    // 使用隐藏价格字段格式来格式化总价
    const formattedPrice = this.formatPrice(totalPrice);
    
    const priceHtml = `<span class="products-summary-price">${formattedPrice}</span>`;
    summaryEl.innerHTML = `${productsInfo.join(', ')} | ${priceHtml}`;
  }
  
  updatePriceSummary(groupIndex) {
    const priceEl = document.querySelector(`#price-summary-${groupIndex}`);
    if (!priceEl) return;
    
    const selectedGroup = this.selectedProducts[groupIndex] || {};
    const selectedIds = Object.keys(selectedGroup).filter(id => 
      selectedGroup[id] && selectedGroup[id].quantity > 0);
    
    if (selectedIds.length === 0) {
      priceEl.style.display = 'none';
      return;
    }
    
    // 计算总价 - 与 updateSummary 相同的逻辑
    let totalPrice = 0;
    
    for (const variantId of selectedIds) {
      const product = selectedGroup[variantId];
      const quantity = product.quantity || 0;
      
      // 获取价格 - 检查是否已经转换过
      let productPrice = 0;
      let priceAlreadyConverted = false;
      
      // 从隐藏价格字段获取价格
      const item = document.querySelector(`.matching-product-item[data-variant-id="${variantId}"]`);
      if (item) {
        const hiddenPriceField = item.querySelector('.hidden-product-price .money');
        if (hiddenPriceField) {
          const priceText = hiddenPriceField.textContent.trim();
          productPrice = this.parsePrice(priceText);
          priceAlreadyConverted = true; // 隐藏价格字段已经是转换后的价格
        }
      }
      
      // 如果没有从隐藏字段获取到价格，使用存储的数据
      if (productPrice <= 0 && this.productData[variantId]) {
        productPrice = this.productData[variantId].price;
        priceAlreadyConverted = !Number.isInteger(productPrice) || productPrice < 100;
      }
      
      // 如果还是没有价格，使用产品对象中的价格
      if (productPrice <= 0) {
        productPrice = product.price || 0;
        priceAlreadyConverted = !Number.isInteger(productPrice) || productPrice < 100;
      }
      
      // 调整价格单位
      productPrice = this.adjustPriceUnit(productPrice, priceAlreadyConverted);
      
      // 累加到总价
      totalPrice += productPrice * quantity;
    }
    
    // 格式化价格
    const formattedPrice = this.formatPrice(totalPrice);
    
    // 检测是否为德语环境
    const isGerman = document.documentElement.lang?.startsWith('de');
    
    // 更新价格摘要HTML
    if (isGerman) {
      priceEl.innerHTML = `<span>Durch die Auswahl wird der Preis um </span><span style="color:#4CAF50;font-weight:bold;" class="converted-price">${formattedPrice}</span><span> erhöht</span>`;
    } else {
      priceEl.innerHTML = `<span>Selection will add </span><span style="color:#4CAF50;font-weight:bold;" class="converted-price">${formattedPrice}</span><span> to the price</span>`;
    }
    
    priceEl.style.display = 'block';
  }
  
  loadProductImages() {
    const items = document.querySelectorAll('.matching-product-item');
    console.log(`开始加载 ${items.length} 个产品图片`);
    
    if (items.length === 0) {
      console.error('找不到产品项元素，尝试重新从元字段数据生成');
      this.createProductItemsFromMetafields();
      return;
    }
    
    items.forEach(item => {
      const variantId = item.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('产品项没有变体ID:', item);
        return;
      }
      
      console.log(`加载变体 ${variantId} 的数据`);
      
      // 使用Shopify API获取变体数据
      fetch(`/variants/${variantId}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error('变体API请求失败');
          }
          return response.json();
        })
        .then(variant => {
          console.log(`成功获取变体 ${variantId} 数据:`, variant);
          
          // 存储变体数据，优先使用name字段作为完整名称
          this.productData[variantId] = {
            title: variant.title || variant.option1 || '',
            price: variant.price / 100,
            handle: variant.handle || '',
            product_id: variant.product_id,
            // 使用name字段存储完整产品名称（包含产品名和变体名）
            name: variant.name || '',
            product_title: variant.product_title || ''
          };
          
          // 创建或更新隐藏价格字段
          this.updateHiddenPriceField(variantId, variant.price / 100);
          
          // 如果没有name字段和产品名称，尝试获取
          if ((!this.productData[variantId].name || !this.productData[variantId].product_title) && variant.product_id) {
            this.fetchProductTitle(variant.product_id, variantId);
          }
          
          // 更新图片
          const img = item.querySelector('.matching-product-image');
          if (img && variant.featured_image) {
            img.src = variant.featured_image.src;
            img.alt = this.productData[variantId].name || this.productData[variantId].title || 'Product image';
            
            // 创建并添加悬停卡片（如果不存在）
            if (!item.querySelector('.hover-card')) {
              const productName = this.productData[variantId].name || variant.name || 
                `${variant.product_title || ''} ${variant.title !== 'Default Title' ? '- ' + variant.title : ''}`;
              
              const hoverCardHTML = `
                <div class="hover-card">
                  <div class="hover-card-image">
                    <img src="${variant.featured_image.src}" alt="${productName}" class="hover-preview-image">
                  </div>
                  <p class="hover-card-title">${productName}</p>
                </div>
              `;
              
              // 将悬停卡片添加到产品项的顶部，而不是图片容器内部
              item.insertAdjacentHTML('afterbegin', hoverCardHTML);
              
              // 添加调试输出
              console.log('已添加悬停卡片到变体ID:', variantId);
            }
          }
          
          // 隐藏加载器
          const loader = item.querySelector('.image-loader');
          if (loader) {
            loader.style.display = 'none';
          }
          
          // 初始化选择
          const input = item.querySelector('.quantity-input');
          if (input && parseInt(input.value) > 0) {
            const groupIndex = item.getAttribute('data-group-index');
            this.updateProductSelection(variantId, parseInt(input.value), groupIndex);
          }
        })
        .catch(error => {
          console.error(`获取变体 ${variantId} 数据失败:`, error);
          // 使用备用方法
          this.loadProductFallback(item, variantId);
        });
    });
  }
  
  // 创建产品预览浮框
  createProductPreview(item, variant) {
    // 检查是否已经存在预览框
    if (item.querySelector('.product-hover-preview')) {
      return;
    }
    
    // 获取完整的产品名称
    const variantId = item.getAttribute('data-variant-id');
    const productName = this.productData[variantId]?.name || variant.name || 
      `${variant.product_title || ''} ${variant.title !== 'Default Title' ? '- ' + variant.title : ''}`;
    
    // 获取图片URL
    let imageUrl = '';
    if (variant.featured_image) {
      imageUrl = variant.featured_image.src;
    }
    
    // 创建预览框HTML
    const previewHtml = `
      <div class="product-hover-preview">
        <div class="preview-image-container">
          <img src="${imageUrl}" alt="${productName}" class="preview-image">
        </div>
        <p class="preview-title">${productName}</p>
      </div>
    `;
    
    // 添加预览框到产品项
    item.insertAdjacentHTML('beforeend', previewHtml);
  }
  
  
  // 如果模板中的产品项未正确生成，从元字段数据创建
  createProductItemsFromMetafields() {
    if (!this.metafieldData || !Array.isArray(this.metafieldData)) {
      console.error('无法从元字段数据创建产品项：数据无效');
      return;
    }
    
    console.log('从元字段数据创建产品项:', this.metafieldData);
    
    // 清除已有的产品容器中的内容
    const container = document.querySelector('.matching-products-container');
    if (!container) {
      console.error('找不到产品容器元素');
      return;
    }
    
    // 创建产品组和产品项
    this.metafieldData.forEach((group, groupIndex) => {
      const groupEl = document.querySelector(`.matching-ways-block[data-group-index="${groupIndex}"]`);
      
      if (!groupEl) {
        console.error(`找不到产品组 ${groupIndex} 的元素`);
        return;
      }
      
      const grid = groupEl.querySelector('.matching-products-grid');
      if (!grid) {
        console.error(`找不到产品组 ${groupIndex} 的网格元素`);
        return;
      }
      
      // 清除网格内容
      grid.innerHTML = '';
      
      // 创建产品项
      if (group.sku_list && Array.isArray(group.sku_list)) {
        group.sku_list.forEach((skuPath) => {
          // 解析变体ID
          let variantId;
          if (typeof skuPath === 'string' && skuPath.includes('/')) {
            const parts = skuPath.split('/');
            variantId = parts[parts.length - 1];
          } else {
            variantId = skuPath;
          }
          
          if (!variantId) return;
          
          // 创建产品项HTML
          const productItemHTML = `
            <div class="matching-product-item" data-variant-id="${variantId}" data-group-index="${groupIndex}">
              <div class="matching-product-image-wrapper">
                <div class="image-loader">Loading...</div>
                <a href="#" class="matching-product-link" data-variant-id="${variantId}">
                  <img 
                    src=""
                    alt="Product"
                    class="matching-product-image"
                    width="120"
                    height="120"
                    loading="lazy"
                  >
                </a>
              </div>
              
              <div class="matching-product-quantity">
                <button class="quantity-btn quantity-minus" data-action="decrease">-</button>
                <input type="text" class="quantity-input" value="0" min="0" aria-label="Quantity">
                <button class="quantity-btn quantity-plus" data-action="increase">+</button>
              </div>
            </div>
          `;
          
          // 添加到网格
          grid.insertAdjacentHTML('beforeend', productItemHTML);
        });
      }
    });
    
    // 重新设置事件监听器
    this.setupEventListeners();
    
    // 重新加载产品图片和信息
    this.loadProductImages();
  }
  
  // 获取所有选定的产品
  getAllSelectedProducts() {
    const allSelected = [];
    
    Object.values(this.selectedProducts).forEach(group => {
      Object.entries(group).forEach(([variantId, product]) => {
        if (product.quantity > 0) {
          allSelected.push({
            id: parseInt(variantId),
            quantity: product.quantity
          });
        }
      });
    });
    
    return allSelected;
  }
  
  // 修改updateCart方法用于主产品添加到购物车时一并添加匹配产品
  addSelectedProductsToCart() {
    const selectedProducts = this.getAllSelectedProducts();
    
    if (selectedProducts.length === 0) return;
    
    console.log('添加选定的匹配产品到购物车:', selectedProducts);
    
    // 这个方法将在主产品的Add to Cart事件中调用
    return selectedProducts;
  }
  
  updateHiddenPriceField(variantId, price) {
    const item = document.querySelector(`.matching-product-item[data-variant-id="${variantId}"]`);
    if (!item) return;
    
    // 检查是否已有隐藏价格字段
    let hiddenPriceField = item.querySelector('.hidden-product-price');
    
    // 生成HTML，支持原始价格和转换后价格
    let priceHTML = '';
    
    if (this.hasCurrencyConverter) {
      // 查找页面上转换后的价格格式
      const baseElement = document.querySelector('.buckscc-converted');
      let formattedPrice = `${this.currency}${price.toFixed(2)}`;
      
      if (baseElement) {
        const currentFormat = baseElement.getAttribute('bucks-current');
        if (currentFormat) {
          const numberMatch = currentFormat.match(/[\d,\.]+/);
          if (numberMatch) {
            const originalPrice = parseFloat(baseElement.getAttribute('bucks-init') || '0');
            if (originalPrice > 0) {
              const convertedNumber = parseFloat(numberMatch[0].replace(/,/g, ''));
              if (convertedNumber > 0) {
                // 计算转换率并应用到当前价格
                const conversionRate = convertedNumber / originalPrice;
                const calculatedPrice = price * conversionRate;
                
                // 格式化数字并应用到模板
                const formattedNumber = calculatedPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                const template = currentFormat.replace(numberMatch[0], '{price}');
                formattedPrice = template.replace('{price}', formattedNumber);
              }
            }
          }
        }
      }
      
      priceHTML = `
        <span data-product-price="" class="product__price hidden-product-price" style="display:none;">
          <span class="money" >
            <span class="cbb-currency">${formattedPrice}</span>
          </span>
        </span>
      `;
    } else {
      priceHTML = `
        <span data-product-price="" class="product__price hidden-product-price" style="display:none;">
          <span class="money"><span class="cbb-currency">${this.currency}${price.toFixed(2)}</span></span>
        </span>
      `;
    }
    
    if (!hiddenPriceField) {
      // 创建隐藏价格字段
      item.insertAdjacentHTML('beforeend', priceHTML);
    } else {
      // 更新已有价格字段
      hiddenPriceField.outerHTML = priceHTML;
    }
  }

  // 添加货币转换相关方法
  detectCurrencyConverter() {
    console.log('检测货币转换插件');
    
    // 查找转换后的价格元素
    const bucksccElements = document.querySelectorAll('.buckscc-converted');
    
    if (bucksccElements.length > 0) {
      this.hasCurrencyConverter = true;
      
      // 从第一个找到的元素获取货币信息
      for (let i = 0; i < Math.min(bucksccElements.length, 5); i++) {
        const element = bucksccElements[i];
        const currency = element.getAttribute('bucks-currency');
        const current = element.getAttribute('bucks-current');
        
        if (currency && current) {
          this.convertedCurrency = currency;
          
          // 保存完整货币格式并提取符号
          const currencySpan = element.querySelector('.cbb-currency');
          if (currencySpan && currencySpan.textContent) {
            // 保存完整文本显示
            this.fullCurrencyText = currencySpan.textContent;
            
            // 提取货币符号（非数字部分）
            const symbolMatch = currencySpan.textContent.match(/[^\d\.,\s]+/);
            if (symbolMatch) {
              this.currencySymbol = symbolMatch[0];
            }
          } else {
            // 如果找不到具体的节点，直接从属性中提取
            this.fullCurrencyText = current;
            const symbolMatch = current.match(/[^\d\.,\s]+/);
            if (symbolMatch) {
              this.currencySymbol = symbolMatch[0];
            }
          }
          
          console.log('成功检测货币转换:', {
            currency: this.convertedCurrency,
            symbol: this.currencySymbol,
            fullText: this.fullCurrencyText
          });
          
          break;
        }
      }
    } else {
      console.log('未检测到货币转换插件');
      this.hasCurrencyConverter = false;
    }
  }

  // 修改 setupCurrencyConversionObserver 方法来限制观察范围和处理频率
  setupCurrencyConversionObserver() {
    if (typeof MutationObserver === 'undefined') return;
    
    // 添加一个防抖处理
    let processingUpdate = false;
    let updateTimeout = null;
    
    // 创建一个观察器实例
    const observer = new MutationObserver((mutations) => {
      // 防止重复处理 - 如果已经在处理，则返回
      if (processingUpdate) return;
      
      // 检查是否有货币相关的变化
      let currencyChanged = false;
      
      for (let i = 0; i < mutations.length; i++) {
        const mutation = mutations[i];
        const target = mutation.target;
        
        // 只检查与货币转换相关的元素
        if (target.classList && (
            target.classList.contains('buckscc-money') || 
            target.classList.contains('buckscc-converted') ||
            target.classList.contains('cbb-currency'))) {
          currencyChanged = true;
          break; // 一旦发现变化就停止循环
        }
      }
      
      if (currencyChanged) {
        // 设置处理标志
        processingUpdate = true;
        
        // 清除任何现有的超时
        if (updateTimeout) {
          clearTimeout(updateTimeout);
        }
        
        // 使用延迟处理，限制更新频率
        updateTimeout = setTimeout(() => {
          try {
            // 重新检测货币转换状态
            this.detectCurrencyConverter();
            
            // 更新所有价格显示
            this.updateAllPriceSummaries();
          } finally {
            // 处理完成，重置标志
            processingUpdate = false;
            updateTimeout = null;
          }
        }, 500); // 500ms 防抖延迟
      }
    });
    
    // 配置观察选项 - 限制观察范围
    const config = { 
      attributes: true,
      subtree: true,
      attributeFilter: ['bucks-currency', 'bucks-current'] // 只观察特定属性
    };
    
    // 只观察与货币相关的元素，而不是整个 document.body
    const currencyElements = document.querySelectorAll('.buckscc-money, .buckscc-converted, .money');
    currencyElements.forEach(el => {
      observer.observe(el, config);
    });
    
    // 如果找不到转换元素，则使用有限的document.body观察
    if (currencyElements.length === 0) {
      // 观察body但配置更严格
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false // 不观察属性变化
      });
    }
  }

  // 优化 updateAllPriceSummaries 方法，减少不必要的更新
  updateAllPriceSummaries() {
    // 检查是否有选择的产品，如果没有就不需要更新
    let hasSelectedProducts = false;
    
    for (const groupIndex in this.selectedProducts) {
      if (Object.keys(this.selectedProducts[groupIndex]).length > 0) {
        hasSelectedProducts = true;
        break;
      }
    }
    
    if (!hasSelectedProducts) return;
    
    // 更新所有组的价格摘要，但使用更高效的方式
    const groups = new Set(Object.keys(this.selectedProducts));
    
    groups.forEach(groupIndex => {
      // 只更新有产品的组
      if (Object.keys(this.selectedProducts[groupIndex]).length > 0) {
        this.updateSummary(groupIndex);
        
        // 检查是否有显示的价格摘要，避免不必要的更新
        const priceEl = document.querySelector(`#price-summary-${groupIndex}`);
        if (priceEl && priceEl.style.display === 'block') {
          // 找出最后选择的产品而不是所有产品
          let lastSelectedVariantId = null;
          let maxQuantity = 0;
          
          Object.entries(this.selectedProducts[groupIndex]).forEach(([variantId, product]) => {
            if (product.quantity > maxQuantity) {
              maxQuantity = product.quantity;
              lastSelectedVariantId = variantId;
            }
          });
          
          if (lastSelectedVariantId) {
            this.updatePriceSummary(groupIndex);
          }
        }
      }
    });
  }

  // 优化 getConvertedPriceForTotal 方法，添加缓存
  getConvertedPriceForTotal(totalPrice) {
    const baseElement = document.querySelector('.buckscc-converted');
    if (!baseElement) return '';
    
    // 获取完整的转换后价格格式
    const currentFormat = baseElement.getAttribute('bucks-current');
    if (!currentFormat) return '';
    
    // 提取数字部分和格式模板
    const numberMatch = currentFormat.match(/[\d,\.]+/);
    if (!numberMatch) return '';
    
    const originalPrice = parseFloat(baseElement.getAttribute('bucks-init') || '0');
    if (originalPrice <= 0) return '';
    
    const convertedNumber = parseFloat(numberMatch[0].replace(/,/g, ''));
    if (convertedNumber <= 0) return '';
    
    // 计算转换率
    const conversionRate = convertedNumber / originalPrice;
    
    // 计算当前总价的转换后金额
    const calculatedPrice = totalPrice * conversionRate;
    
    // 格式化为相同格式 (保留原始格式中的千位分隔符等)
    const formattedNumber = calculatedPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    
    // 将格式化的数字插入到原始格式模板中
    const formatTemplate = currentFormat.replace(numberMatch[0], '{price}');
    return formatTemplate.replace('{price}', formattedNumber);
  }

  // 添加获取产品转换后价格的方法
  getConvertedPriceForProduct(variantId, totalPrice) {
    // 尝试从该产品的隐藏价格字段获取转换后的价格
    const item = document.querySelector(`.matching-product-item[data-variant-id="${variantId}"]`);
    if (item) {
      const hiddenPriceField = item.querySelector('.hidden-product-price .buckscc-converted');
      if (hiddenPriceField) {
        const convertedText = hiddenPriceField.getAttribute('bucks-current');
        if (convertedText) {
          // 提取数字部分
          const priceMatch = convertedText.match(/[\d,\.]+/);
          if (priceMatch) {
            const unitPrice = parseFloat(priceMatch[0].replace(/,/g, ''));
            
            // 计算总价
            const calculatedTotal = unitPrice * (totalPrice / this.productData[variantId].price);
            
            // 格式化为与原始转换后价格相同的格式
            const currencyFormat = convertedText.replace(/[\d,\.]+/, '');
            return `${currencyFormat}${calculatedTotal.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
          }
        }
      }
    }
    
    // 回退到通用转换方法
    return this.getConvertedPriceForTotal(totalPrice);
  }

  // 添加专门监听产品价格元素变化的方法
  setupPriceElementObserver() {
    if (typeof MutationObserver === 'undefined') return;
    
    // 创建价格元素监听器
    const priceObserver = new MutationObserver((mutations) => {
      let priceChanged = false;
      
      // 检查是否是价格元素变化
      for (const mutation of mutations) {
        const target = mutation.target;
        
        // 检查目标元素或其父元素是否为价格相关元素
        if (target.classList && (
            target.classList.contains('product__price') || 
            target.hasAttribute('data-product-price') ||
            target.hasAttribute('data-product-price-wrap') ||
            target.hasAttribute('data-compare-price') ||
            target.querySelector('.product__price, [data-product-price], [data-compare-price]')
          )) {
          priceChanged = true;
          break;
        }
      }
      
      if (priceChanged) {
        // 使用延迟以允许所有价格更新完成
        setTimeout(() => {
          // 重新检测货币转换器
          this.detectCurrencyConverter();
          
          // 更新所有价格摘要
          this.updateAllPriceSummaries();
        }, 300);
      }
    });
    
    // 选择所有可能的价格元素
    const priceSelectors = [
      '.product__price',
      '[data-product-price]',
      '[data-product-price-wrap]',
      '[data-compare-price]',
      '.money',
      '.price-item'
    ];
    
    // 观察所有价格相关元素
    document.querySelectorAll(priceSelectors.join(', ')).forEach(el => {
      priceObserver.observe(el, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    });
    
    // 另外，观察document.body中特定元素的添加
    const bodyObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // 检查添加的节点是否包含价格元素
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const priceElements = node.querySelectorAll(priceSelectors.join(', '));
              
              if (priceElements.length > 0) {
                // 为新添加的价格元素添加观察器
                priceElements.forEach(el => {
                  priceObserver.observe(el, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true
                  });
                });
                
                // 重新检测货币转换器
                setTimeout(() => {
                  this.detectCurrencyConverter();
                  this.updateAllPriceSummaries();
                }, 300);
                
                break;
              }
            }
          }
        }
      }
    });
    
    // 观察body元素以捕获新添加的价格元素
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }

  // 修复格式化价格函数以处理 NaN
  formatPrice(price) {
    // 确保价格是有效数字
    if (isNaN(price) || typeof price !== 'number') {
      console.warn('检测到无效价格，使用0替代:', price);
      price = 0;
    }
    
    const format = this.getPriceFormat() || {
      isEuroFormat: false,
      currencyAtEnd: false,
      currencySymbol: this.currency
    };
    
    // 检测是否为日元(¥)或其他整数货币
    const isYenCurrency = format.currencySymbol === '¥' || 
                         format.currencySymbol === 'JPY' || 
                         format.currencySymbol.includes('JPY');
    
    let formattedNumber = '';
    
    if (isYenCurrency) {
      // 日元：不使用小数点，只显示整数
      formattedNumber = Math.round(price).toString();
      
      // 添加千位分隔符
      formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else if (format.isEuroFormat) {
      // 欧式格式：用逗号作为小数点
      formattedNumber = price.toFixed(2).replace('.', ',');
    } else {
      // 美式格式：用点作为小数点
      formattedNumber = price.toFixed(2);
    }
    
    // 根据货币符号位置返回格式化的价格
    if (format.currencyAtEnd) {
      return `${formattedNumber} ${format.currencySymbol}`;
    } else {
      return `${format.currencySymbol}${formattedNumber}`;
    }
  }
  
  // 改进解析价格函数
  parsePrice(priceText) {
    if (!priceText) return 0;
    
    // 添加调试日志
    console.debug('解析价格文本:', priceText);
    
    // 移除货币符号和空格，保留数字、点和逗号
    const cleanPrice = priceText.replace(/[^0-9.,]/g, '').trim();
    
    if (!cleanPrice) {
      console.warn('价格文本不包含有效数字:', priceText);
      return 0;
    }
    
    // 检测是否为日元货币符号
    const isYenPrice = priceText.includes('¥') || priceText.includes('JPY');
    
    let result = 0;
    
    try {
      if (isYenPrice) {
        // 日元：移除所有分隔符，不处理小数点
        result = parseInt(cleanPrice.replace(/,/g, ''));
      } else {
        // 检测是否使用逗号作为小数点
        const isEuroFormat = /\d+,\d+/.test(cleanPrice) && !/\d+\.\d+/.test(cleanPrice);
        
        if (isEuroFormat) {
          // 欧式格式：移除分组符(点)，将小数点符号(逗号)替换为点
          result = parseFloat(cleanPrice.replace(/\./g, '').replace(',', '.'));
        } else {
          // 美式格式：移除分组符(逗号)
          result = parseFloat(cleanPrice.replace(/,/g, ''));
        }
      }
      
      // 确保结果是有效的数字
      if (isNaN(result)) {
        console.warn('解析价格失败，返回0:', priceText);
        return 0;
      }
      
      return result;
    } catch (error) {
      console.error('解析价格时出错:', error, priceText);
      return 0;
    }
  }
  
  // 改进检测价格格式的方法 - 添加日元识别
  getPriceFormat() {
    // 查找页面上的隐藏价格元素作为参考
    const hiddenPrice = document.querySelector('.hidden-product-price .money');
    if (!hiddenPrice) return null;
    
    const priceText = hiddenPrice.textContent.trim();
    
    // 检测是否为日元
    const isYen = priceText.includes('¥') || priceText.includes('JPY');
    
    // 检测是欧式格式(使用逗号作为小数点)还是美式格式(使用点作为小数点)
    const isEuroFormat = /\d+,\d+/.test(priceText) && !/\d+\.\d+/.test(priceText);
    
    // 获取货币符号位置(前缀或后缀)
    const currencyAtEnd = /\d[,.]\d+\s*[€£¥]/.test(priceText) || 
                          /\d+\s*[€£¥]/.test(priceText);
    
    // 获取货币符号
    let currencySymbol = '';
    const currencyMatch = priceText.match(/[€£¥$]/);
    if (currencyMatch) {
      currencySymbol = currencyMatch[0];
    } else if (priceText.includes('EUR')) {
      currencySymbol = 'EUR';
    } else if (priceText.includes('JPY')) {
      currencySymbol = 'JPY';
    } else {
      currencySymbol = this.currency;
    }
    
    return {
      isYen,
      isEuroFormat,
      currencyAtEnd,
      currencySymbol
    };
  }

  // 检查是否为日元货币的辅助方法
  isYenCurrency() {
    return this.currency === '¥' || 
           this.currency.includes('JPY') || 
           this.convertedCurrency === 'JPY';
  }

  // 修复价格调整逻辑 - 添加转换标志防止重复转换
  adjustPriceUnit(price, alreadyConverted = false) {
    if (typeof price !== 'number' || price <= 0) return price;
    
    // 只有未转换过且非日元货币才需要除以100
    if (!alreadyConverted && !this.isYenCurrency() && Number.isInteger(price) && price > 100) {
      return price / 100; // 非日元货币转换为"元"
    }
    
    return price; // 已转换过或是日元货币则保持原样
  }

}

// 注册Web Component
customElements.define('product-matching-ways', ProductMatchingWays);

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', function() {
  console.log('产品匹配脚本加载完成');
}); 